import styled from 'styled-components'

export const HeaderItem = styled.th`
  &.actions {
    text-align: center;
  }
`
